'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AgentRest = function () {
  function AgentRest($http) {
    (0, _classCallCheck3.default)(this, AgentRest);

    this.$http = $http;
    this.sprintf = require("sprintf-js").sprintf;

    this.PATH = {
      LIST: 'agents/',
      TOGGLE: 'agents/toggle/',
      WIDGETS: 'agents/widgets/',
      DOWNLOAD_REQUEST: 'agents/export-nonce/',
      DOWNLOAD: 'agents/export/',
      DOWNLOAD_BY_ZONE: 'agents/export-by-zone/',
      DETAIL: 'agents/%1$s/',
      AGENT_APPOINTMENTS: 'agents/%1$s/appointments/',
      ZIPCODE_CHECK: 'agents/%1$s/zipcode-check/'
    };
  }

  (0, _createClass3.default)(AgentRest, [{
    key: 'create',
    value: function create(postData) {
      return this.$http.post(this.PATH.LIST, postData);
    }
  }, {
    key: 'update',
    value: function update(id, postData) {
      return this.$http.put(this.sprintf(this.PATH.DETAIL, id), postData);
    }
  }, {
    key: 'save',
    value: function save(postData) {
      return postData.id !== null ? this.update(postData.id, postData) : this.create(postData);
    }
  }, {
    key: 'toggle',
    value: function toggle(postData) {
      return this.$http.post(this.PATH.TOGGLE, postData);
    }
  }, {
    key: 'getList',
    value: function getList(params) {
      return this.$http.get(this.PATH.LIST, { params: params });
    }
  }, {
    key: 'widgets',
    value: function widgets(params) {
      return this.$http.get(this.PATH.WIDGETS, { params: params });
    }
  }, {
    key: 'get',
    value: function get(id) {
      return this.$http.get(this.sprintf(this.PATH.DETAIL, id));
    }
  }, {
    key: 'options',
    value: function options() {
      return this.$http({
        url: this.PATH.LIST,
        method: 'OPTIONS',
        responseType: 'json' });
    }
  }, {
    key: 'agentAPIOptions',
    value: function agentAPIOptions(id) {
      return this.$http({
        url: this.sprintf(this.PATH.DETAIL, id),
        method: 'OPTIONS',
        responseType: 'json' });
    }
  }, {
    key: 'getAgentAppointments',
    value: function getAgentAppointments(id) {
      return this.$http.get(this.sprintf(this.PATH.AGENT_APPOINTMENTS, id));
    }
  }, {
    key: 'checkZipcode',
    value: function checkZipcode(id, zipcode) {
      var postData = { 'zipcode': zipcode };
      return this.$http.post(this.sprintf(this.PATH.ZIPCODE_CHECK, id), postData);
    }
  }, {
    key: 'downloadRequest',
    value: function downloadRequest() {
      return this.$http.post(this.PATH.DOWNLOAD_REQUEST);
    }
  }, {
    key: 'download',
    value: function download(params) {
      var querystring = "";
      for (var k in params) {

        var value = params[k];

        if (Array.isArray(value)) {
          value.forEach(function (item) {
            querystring += (querystring !== '' ? '&' : '') + encodeURIComponent(k + '[]') + "=" + encodeURIComponent(item);
          });
        } else {
          querystring += (querystring !== '' ? '&' : '') + encodeURIComponent(k) + "=" + encodeURIComponent(params[k]);
        }
      }
      var url = this.$http.options.root + "/" + this.PATH.DOWNLOAD + "?" + querystring;
      window.open(url, "_blank");
    }
  }]);
  return AgentRest;
}();

exports.default = AgentRest;


//////////////////
// WEBPACK FOOTER
// ./src/api/AgentResource.js
// module id = 304
// module chunks = 0